// Animation Types
var AnimationDirection;

(function (AnimationDirection) {
  AnimationDirection["Top"] = "top";
  AnimationDirection["Right"] = "right";
  AnimationDirection["Bottom"] = "bottom";
  AnimationDirection["Left"] = "left";
})(AnimationDirection || (AnimationDirection = {}));

// Anchored Layer types
var AnchoredLayerBoundariesElement;

(function (AnchoredLayerBoundariesElement) {
  AnchoredLayerBoundariesElement["Viewport"] = "viewport";
  AnchoredLayerBoundariesElement["Window"] = "window";
  AnchoredLayerBoundariesElement["ScrollParent"] = "scrollParent";
})(AnchoredLayerBoundariesElement || (AnchoredLayerBoundariesElement = {}));

var AnchoredLayerPosition;

(function (AnchoredLayerPosition) {
  AnchoredLayerPosition["TopLeft"] = "top-start";
  AnchoredLayerPosition["TopCenter"] = "top";
  AnchoredLayerPosition["TopRight"] = "top-end";
  AnchoredLayerPosition["RightTop"] = "right-start";
  AnchoredLayerPosition["RightCenter"] = "right";
  AnchoredLayerPosition["RightBottom"] = "right-end";
  AnchoredLayerPosition["BottomLeft"] = "bottom-start";
  AnchoredLayerPosition["BottomCenter"] = "bottom";
  AnchoredLayerPosition["BottomRight"] = "bottom-end";
  AnchoredLayerPosition["LeftTop"] = "left-start";
  AnchoredLayerPosition["LeftCenter"] = "left";
  AnchoredLayerPosition["LeftBottom"] = "left-end";
})(AnchoredLayerPosition || (AnchoredLayerPosition = {}));

//LayerManager Types
var LayerManagerLayer;

(function (LayerManagerLayer) {
  LayerManagerLayer["PopoverContent"] = "POPOVER_CONTENT";
  LayerManagerLayer["Sheet"] = "SHEET";
  LayerManagerLayer["Modal"] = "MODAL";
  LayerManagerLayer["PopoverModal"] = "POPOVER_MODAL";
  LayerManagerLayer["Viewport"] = "VIEWPORT";
})(LayerManagerLayer || (LayerManagerLayer = {}));

export { AnchoredLayerBoundariesElement, AnchoredLayerPosition, AnimationDirection, LayerManagerLayer };
